export default function (els, selector, limitOne = false) {
	const matches = [];

	if (els) {
		for (let i = 0; i < els.length; i++) {
			const $target = els[i];
			const $queryResult = $target.parentNode.querySelector(`${selector}`);
			if ($queryResult === $target) {
				matches.push($queryResult);

				if (limitOne) {
					return $queryResult;
				}
			}
		}
	}

	return matches;
}
